<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-divider></v-divider>
    
    <!-- Range layout -->
    <v-layout wrap fill-height v-if="appUser === 'range'">
      <v-flex xs12 sm12 md2 lg2 class="hidden-sm-and-down">
        <v-navigation-drawer class="fixedSidebar modern-sidebar" clipped width="100%" height="100vh" permanent>
          <!-- Logo area -->
          <div class="sidebar-logo-area">
            <v-img contain width="100%" height="70px" src="../assets/sidelogo.png" fill-height></v-img>
          </div>

          <!-- Section Toggle -->
          <div class="sidebar-section-toggle">
            <button
              class="section-btn"
              :class="{ active: activeSection === 'hwc' }"
              @click="setActiveSection('hwc')"
            >HWC</button>
            <button
              class="section-btn"
              :class="{ active: activeSection === 'sarpa' }"
              @click="setActiveSection('sarpa')"
            >SARPA</button>
          </div>

          <div class="sidebar-divider"></div>

          <!-- HWC Menu -->
          <div class="sidebar-scroll" v-if="activeSection === 'hwc'">
            <div
              v-for="item in rangeitems"
              :key="item.title"
              class="sidebar-item"
              :class="{ 'sidebar-item--active': $route.path === item.path }"
              @click="$router.push(item.path)"
            >
              <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
              <span class="sidebar-label">{{ item.title }}</span>
              <span class="sidebar-active-bar"></span>
            </div>
          </div>

          <!-- SARPA Menu -->
          <div class="sidebar-scroll" v-if="activeSection === 'sarpa'">
            <div
              v-for="item in sarpadashboard"
              :key="item.title"
              class="sidebar-item"
              :class="{ 'sidebar-item--active': $route.path === item.path }"
              @click="$router.push(item.path)"
            >
              <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
              <span class="sidebar-label">{{ item.title }}</span>
              <span class="sidebar-active-bar"></span>
            </div>
          </div>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 sm12 md10 lg10>
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0 v-if="activeSection === 'hwc'">
            <AppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex
            xs12
            sm12
            md12
            lg12
            pb-0
            mb-0
            v-if="activeSection === 'sarpa'"
          >
            <SarpaAppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0
            ><v-divider class="pt-0 mt-0"></v-divider
          ></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-3>
            <v-layout
              wrap
              justify-center
              style="background-color: #eef3ea"
            >
              <v-flex xs12>
                <v-card
                  min-height="100vh"
                  :color="
                    $route.name == 'dashboard' ? 'transparent' : '#FFFFFF'
                  "
                  flat
                >
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    
    <!-- Division layout -->
    <v-layout wrap fill-height v-else-if="appUser === 'division'">
      <v-flex xs12 sm12 md2 lg2 class="hidden-sm-and-down">
        <v-navigation-drawer class="fixedSidebar modern-sidebar" clipped width="100%" height="100vh" permanent>
          <!-- Logo area -->
          <div class="sidebar-logo-area">
            <v-img contain width="100%" height="70px" src="../assets/sidelogo.png" fill-height></v-img>
          </div>

          <!-- Section Toggle -->
          <div class="sidebar-section-toggle">
            <button
              class="section-btn"
              :class="{ active: activeSection === 'hwc' }"
              @click="setActiveSection('hwc')"
            >HWC</button>
            <button
              class="section-btn"
              :class="{ active: activeSection === 'sarpa' }"
              @click="setActiveSection('sarpa')"
            >SARPA</button>
          </div>

          <div class="sidebar-divider"></div>

          <!-- HWC Menu -->
          <div class="sidebar-scroll" v-if="activeSection === 'hwc'">
            <div
              v-for="item in divisionitems"
              :key="item.title"
              class="sidebar-item"
              :class="{ 'sidebar-item--active': $route.path === item.path }"
              @click="$router.push(item.path)"
            >
              <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
              <span class="sidebar-label">{{ item.title }}</span>
              <span class="sidebar-active-bar"></span>
            </div>
          </div>

          <!-- SARPA Menu -->
          <div class="sidebar-scroll" v-if="activeSection === 'sarpa'">
            <div
              v-for="item in sarpadashboard"
              :key="item.title"
              class="sidebar-item"
              :class="{ 'sidebar-item--active': $route.path === item.path }"
              @click="$router.push(item.path)"
            >
              <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
              <span class="sidebar-label">{{ item.title }}</span>
              <span class="sidebar-active-bar"></span>
            </div>
          </div>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 sm12 md10 lg10>
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0 v-if="activeSection === 'hwc'">
            <AppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex
            xs12
            sm12
            md12
            lg12
            pb-0
            mb-0
            v-if="activeSection === 'sarpa'"
          >
            <SarpaAppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0
            ><v-divider class="pt-0 mt-0"></v-divider
          ></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-3>
            <v-layout
              wrap
              justify-center
              :style="
                $route.name == 'dashboard'
                  ? 'background-color: #ffffff'
                  : 'background-color: #f6fff9'
              "
            >
              <v-flex xs12>
                <v-card
                  min-height="100vh"
                  :color="
                    $route.name == 'dashboard' ? 'transparent' : '#FFFFFF'
                  "
                  flat
                >
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    
    <!-- Circle layout -->
    <v-layout wrap fill-height v-else-if="appUser === 'circle'">
      <v-flex xs12 sm12 md2 lg2 class="hidden-sm-and-down">
        <v-navigation-drawer class="fixedSidebar modern-sidebar" clipped width="100%" height="100vh" permanent>
          <!-- Logo area -->
          <div class="sidebar-logo-area">
            <v-img contain width="100%" height="70px" src="../assets/sidelogo.png" fill-height></v-img>
          </div>

          <!-- Section Toggle -->
          <div class="sidebar-section-toggle">
            <button
              class="section-btn"
              :class="{ active: activeSection === 'hwc' }"
              @click="setActiveSection('hwc')"
            >HWC</button>
            <button
              class="section-btn"
              :class="{ active: activeSection === 'sarpa' }"
              @click="setActiveSection('sarpa')"
            >SARPA</button>
          </div>

          <div class="sidebar-divider"></div>

          <!-- HWC Menu -->
          <div class="sidebar-scroll" v-if="activeSection === 'hwc'">
            <div
              v-for="item in circleitems"
              :key="item.title"
              class="sidebar-item"
              :class="{ 'sidebar-item--active': $route.path === item.path }"
              @click="$router.push(item.path)"
            >
              <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
              <span class="sidebar-label">{{ item.title }}</span>
              <span class="sidebar-active-bar"></span>
            </div>
          </div>

          <!-- SARPA Menu -->
          <div class="sidebar-scroll" v-if="activeSection === 'sarpa'">
            <div
              v-for="item in sarpadashboard"
              :key="item.title"
              class="sidebar-item"
              :class="{ 'sidebar-item--active': $route.path === item.path }"
              @click="$router.push(item.path)"
            >
              <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
              <span class="sidebar-label">{{ item.title }}</span>
              <span class="sidebar-active-bar"></span>
            </div>
          </div>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 sm12 md10 lg10>
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0 v-if="activeSection === 'hwc'">
            <AppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex
            xs12
            sm12
            md12
            lg12
            pb-0
            mb-0
            v-if="activeSection === 'sarpa'"
          >
            <SarpaAppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0
            ><v-divider class="pt-0 mt-0"></v-divider
          ></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-3>
            <v-layout
              wrap
              justify-center
              :style="
                $route.name == 'dashboard'
                  ? 'background-color: #ffffff'
                  : 'background-color: #f6fff9'
              "
            >
              <v-flex xs12>
                <v-card
                  min-height="100vh"
                  :color="
                    $route.name == 'dashboard' ? 'transparent' : '#FFFFFF'
                  "
                  flat
                >
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    
    <!-- RRT layout -->
    <v-layout wrap fill-height v-else-if="appUser === 'RRT'">
      <v-flex xs12 sm12 md2 lg2 class="hidden-sm-and-down">
        <v-navigation-drawer class="fixedSidebar modern-sidebar" clipped width="100%" height="100vh" permanent>
          <!-- Logo area -->
          <div class="sidebar-logo-area">
            <v-img contain width="100%" height="70px" src="../assets/sidelogo.png" fill-height></v-img>
          </div>

          <div class="sidebar-divider"></div>

          <div class="sidebar-scroll">
            <div
              v-for="item in items"
              :key="item.title"
              class="sidebar-item"
              :class="{ 'sidebar-item--active': $route.path === item.path }"
              @click="$router.push(item.path)"
            >
              <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
              <span class="sidebar-label">{{ item.title }}</span>
              <span class="sidebar-active-bar"></span>
            </div>
          </div>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 sm12 md10 lg10>
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
            <AppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0
            ><v-divider class="pt-0 mt-0"></v-divider
          ></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-3>
            <v-layout
              wrap
              justify-center
              :style="
                $route.name == 'dashboard'
                  ? 'background-color: #ffffff'
                  : 'background-color: #f6fff9'
              "
            >
              <v-flex xs12>
                <v-card
                  min-height="100vh"
                  :color="
                    $route.name == 'dashboard' ? 'transparent' : '#FFFFFF'
                  "
                  flat
                >
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    
    <!-- DEOC layout -->
    <v-layout wrap fill-height v-else-if="appUser === 'DEOC'">
      <v-flex xs12 sm12 md2 lg2 class="hidden-sm-and-down">
        <v-navigation-drawer class="fixedSidebar modern-sidebar" clipped width="100%" height="100vh" permanent>
          <!-- Logo area -->
          <div class="sidebar-logo-area">
            <v-img contain width="100%" height="70px" src="../assets/sidelogo.png" fill-height></v-img>
          </div>

          <div class="sidebar-divider"></div>

          <div class="sidebar-scroll">
            <div
              v-for="item in seocanddeoc"
              :key="item.title"
              class="sidebar-item"
              :class="{ 'sidebar-item--active': $route.path === item.path }"
              @click="$router.push(item.path)"
            >
              <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
              <span class="sidebar-label">{{ item.title }}</span>
              <span class="sidebar-active-bar"></span>
            </div>
          </div>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 sm12 md10 lg10>
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
            <AppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0
            ><v-divider class="pt-0 mt-0"></v-divider
          ></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-3>
            <v-layout
              wrap
              justify-center
              :style="
                $route.name == 'dashboard'
                  ? 'background-color: #ffffff'
                  : 'background-color: #f6fff9'
              "
            >
              <v-flex xs12>
                <v-card
                  min-height="100vh"
                  :color="
                    $route.name == 'dashboard' ? 'transparent' : '#FFFFFF'
                  "
                  flat
                >
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    
    <!-- Default layout -->
    <v-layout wrap fill-height v-else>
      <v-flex xs12 sm12 md2 lg2 class="hidden-sm-and-down">
        <v-navigation-drawer class="fixedSidebar modern-sidebar" clipped width="100%" height="100vh" permanent>
          <!-- Logo area -->
          <div class="sidebar-logo-area">
            <v-img contain width="100%" height="70px" src="../assets/sidelogo.png" fill-height></v-img>
          </div>

          <div class="sidebar-divider"></div>

          <div class="sidebar-scroll">
            <div
              v-for="item in items"
              :key="item.title"
              class="sidebar-item"
              :class="{ 'sidebar-item--active': $route.path === item.path }"
              @click="$router.push(item.path)"
            >
              <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
              <span class="sidebar-label">{{ item.title }}</span>
              <span class="sidebar-active-bar"></span>
            </div>
          </div>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 sm12 md10 lg10>
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
            <AppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0
            ><v-divider class="pt-0 mt-0"></v-divider
          ></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-3>
            <v-layout
              wrap
              justify-center
              :style="
                $route.name == 'dashboard'
                  ? 'background-color: #ffffff'
                  : 'background-color: #f6fff9'
              "
            >
              <v-flex xs12>
                <v-card
                  min-height="100vh"
                  :color="
                    $route.name == 'dashboard' ? 'transparent' : '#FFFFFF'
                  "
                  flat
                >
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    
    <v-dialog v-model="deocDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Case Report Query</v-card-title>
        <v-card-text>
          Whether there is any case to be reported for the daily report?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="handleDeocYes">Yes</v-btn>
          <v-btn color="error" text @click="handleDeocNo">No</v-btn>
          <v-btn text @click="deocDialog = false">
            <v-icon>mdi-close</v-icon> Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deocRescueDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Rescue Case Report Query</v-card-title>
        <v-card-text>
          Whether there is any rescue case to be reported for the daily rescue report?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="handleRescueDeocYes">Yes</v-btn>
          <v-btn color="error" text @click="handleRescueDeocNo">No</v-btn>
          <v-btn text @click="deocRescueDialog = false">
            <v-icon>mdi-close</v-icon> Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppHeader from "@/components/Common/appHeader";
import SarpaAppHeader from "@/components/Common/appHeadersarpa";
import axios from "axios";

export default {
  components: {
    AppHeader,
    SarpaAppHeader,
  },
  data() {
    return {
      activeSection: localStorage.getItem("activeSection") || "hwc",
      items: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Officers/dashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Officers/profile" },
        {
          title: "Analytics",
          icon: "mdi-home-analytics",
          path: "/Officers/analytics",
        },
        {
          title: "Report Generation",
          icon: "mdi-table",
          path: "/Officers/reportGenerationofficers",
        },
        {
          title: "Closed Cases",
          icon: "mdi-close",
          path: "/Officers/closedcases",
        },
        {
          title: "Notifications",
          icon: "mdi-bell",
          path: "/Officers/notifications",
        },
        {
          title: "Report Case",
          icon: "mdi-file-eye",
          path: "/Officers/reportcase",
        },
      ],
      seocanddeoc: [
        {
          title: "Dashboard",
          icon: "mdi-home-analytics",
          path: "/Officers/analytics",
        },
        {
          title: "Home",
          icon: "mdi-view-dashboard",
          path: "/Officers/dashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Officers/profile" },
        {
          title: "Report Generation",
          icon: "mdi-table",
          path: "/Officers/reportGenerationofficers",
        },
        {
          title: "Notifications",
          icon: "mdi-bell",
          path: "/Officers/notifications",
        },
        {
          title: "Closed Cases",
          icon: "mdi-close",
          path: "/Officers/closedcases",
        },
        {
          title: "Report Case",
          icon: "mdi-file-eye",
          path: "/Officers/reportcase",
        },
        {
          title: "Daily Reporting",
          icon: "mdi-chart-tree",
          path: "/Officers/daily-reporting",
        },
        {
          title: "Daily Report",
          icon: "mdi-file-pdf-box",
          path: "/Officers/daily-report",
        },
        {
          title: "Daily Rescue Reporting",
          icon: "mdi-chart-tree",
          path: "/Officers/daily-reporting-rescue",
        },
        {
          title: "Daily Rescue Report",
          icon: "mdi-file-pdf-box",
          path: "/Officers/daily-report-rescue",
        },
      ],
      rangeitems: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Officers/dashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Officers/profile" },
        {
          title: "Analytics",
          icon: "mdi-home-analytics",
          path: "/Officers/analytics",
        },
        {
          title: "Report Generation",
          icon: "mdi-table",
          path: "/Officers/reportGenerationofficers",
        },
        {
          title: "Closed Cases",
          icon: "mdi-close",
          path: "/Officers/closedcases",
        },
        {
          title: "Notifications",
          icon: "mdi-bell",
          path: "/Officers/notifications",
        },
        {
          title: "Report Case",
          icon: "mdi-file-eye",
          path: "/Officers/reportcase",
        },
      ],
      divisionitems: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Officers/dashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Officers/profile" },
        {
          title: "Analytics",
          icon: "mdi-home-analytics",
          path: "/Officers/analytics",
        },
        {
          title: "Report Generation",
          icon: "mdi-table",
          path: "/Officers/reportGenerationofficers",
        },
        {
          title: "Closed Cases",
          icon: "mdi-close",
          path: "/Officers/closedcases",
        },
        {
          title: "Notifications",
          icon: "mdi-bell",
          path: "/Officers/notifications",
        },
        {
          title: "Report Case",
          icon: "mdi-file-eye",
          path: "/Officers/reportcase",
        },
        {
          title: "DFEOC USER",
          icon: "mdi-account-outline",
          path: "/Officers/adddeoc",
        },
      ],
      circleitems: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Officers/dashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Officers/profile" },
        {
          title: "Analytics",
          icon: "mdi-home-analytics",
          path: "/Officers/analytics",
        },
        {
          title: "Report Generation",
          icon: "mdi-table",
          path: "/Officers/reportGenerationofficers",
        },
        {
          title: "Closed Cases",
          icon: "mdi-close",
          path: "/Officers/closedcases",
        },
        {
          title: "Notifications",
          icon: "mdi-bell",
          path: "/Officers/notifications",
        },
      ],
      sarpadashboard: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/officers/sarpadashboard",
        },
        // {
        //   title: "Pending Operations",
        //   icon: "mdi-receipt-clock-outline",
        //   path: "/officers/pendingoperations",
        // },
        // {
        //   title: "Assigned Operations",
        //   icon: "mdi-clipboard-check",
        //   path: "/officers/assignedoperations",
        // },
        // {
        //   title: "Rescued Operations",
        //   icon: "mdi-invoice-list",
        //   path: "/officers/rescuedoperations",
        // },
        // {
        //   title: "Released Operations",
        //   icon: "mdi-view-list",
        //   path: "/officers/releasedoperations",
        // },
        // {
        //   title: "Approved Operations",
        //   icon: "mdi-playlist-check",
        //   path: "/officers/approvedoperations",
        // },
        {
          title: "Snake Reports",
          icon: "mdi-file-chart",
          path: "/officers/snakereports",
        },
        {
          title: "View Hospital",
          icon: "mdi-hospital-marker",
          path: "/officers/Viewhospital",
        },
        {
          title: "Identification Help",
          icon: "mdi-help-box-multiple-outline",
          path: "/officers/identificationhelp",
        },
        {
          title: "Excel",
          icon: "mdi-file-excel",
          path: "/officers/excelreport",
        },
      ],
      right: null,
      deocDialog: false,
      deocRescueDialog: false,
      showSnackBar: false,
      msg: null,
      timeout: 5000,
    };
  },
  mounted() {
    this.verifyDeocCase();
    this.verifyDeocRescueCase();
  },
  watch: {
    $route() {
      this.verifyDeocCase();
      this.verifyDeocRescueCase();
    }
  },
  methods: {
    verifyDeocCase() {
      if (this.appUser === "DEOC" && this.$route.name === "daily-reporting") {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
        axios({
          method: "GET",
          url: "/deoc_daily_report/check-entry",
          params: {
            date: today
          },
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        })
          .then((response) => {
            if (response.data.data.status === false) {
              this.deocDialog = true;
            } else {
              this.deocDialog = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    verifyDeocRescueCase() {
      if (this.appUser === "DEOC" && this.$route.name === "daily-reporting-rescue") {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
        axios({
          method: "GET",
          url: "/deoc_daily_rescue_report/check-entry",
          params: {
            date: today
          },
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        })
          .then((response) => {
            if (response.data.data.status === false) {
              this.deocRescueDialog = true;
            } else {
              this.deocRescueDialog = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    handleDeocYes() {
      this.deocDialog = false;
      if (this.$route.name !== "daily-reporting") {
        this.$router.push("/Officers/daily-reporting").catch(() => {});
      }
    },
    handleRescueDeocYes() {
      this.deocRescueDialog = false;
      if (this.$route.name !== "daily-reporting-rescue") {
        this.$router.push("/Officers/daily-reporting-rescue").catch(() => {});
      }
    },
    handleDeocNo() {
      axios({
        method: "POST",
        url: "/deoc_daily_report/add",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          loggedWithACase: false,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.deocDialog = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleRescueDeocNo() {
      axios({
        method: "POST",
        url: "/deoc_daily_rescue_report/add",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          loggedWithACase: false,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.deocRescueDialog = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setActiveSection(section) {
      if (section === "hwc") {
        this.$router.push("/Officers/analytics");
      }
      if (section === "sarpa") {
        this.$router.push("/officers/sarpadashboard");
      }
      this.activeSection = section;
      localStorage.setItem("activeSection", section); // Save to localStorage
    },
  },
  computed: {
    appUser() {
      return this.$store.state.userRole;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

/* ── Sidebar shell ─────────────────────────────── */
.modern-sidebar {
  background: linear-gradient(180deg, #183824 0%, #254b31 100%) !important;
  box-shadow: 4px 0 24px rgba(24, 56, 36, 0.15) !important;
  border-right: none !important;
  font-family: 'Inter', sans-serif;
  display: flex !important;
  flex-direction: column !important;
}

/* ── Logo area (fixed header, matches navbar height) */
.sidebar-logo-area {
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  min-height: 60px;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 10;
}

/* ── Section toggle ────────────────────────────── */
.sidebar-section-toggle {
  display: flex;
  gap: 8px;
  padding: 14px 12px 10px;
}

.section-btn {
  flex: 1;
  padding: 7px 0;
  border: 1.5px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  background: transparent;
  color: rgba(255, 255, 255, 0.55);
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1.2px;
  cursor: pointer;
  transition: all 0.25s ease;
  text-transform: uppercase;
}

.section-btn:hover {
  background: rgba(126, 185, 95, 0.15) !important;
  border-color: rgba(126, 185, 95, 0.5) !important;
  color: #7eb95f !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(126, 185, 95, 0.2) !important;
}

.section-btn.active {
  background: linear-gradient(135deg, #7eb95f 0%, #5d9e3b 100%) !important;
  border-color: #7eb95f !important;
  color: #102411 !important;
  box-shadow: 0 4px 16px rgba(126, 185, 95, 0.45) !important;
}

/* ── Divider ───────────────────────────────────── */
.sidebar-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
  margin: 4px 12px 8px;
}

/* ── Scrollable nav area ───────────────────────── */
.sidebar-scroll {
  overflow-y: auto;
  /* 60px logo + 14px top-pad + 44px buttons + 10px bot-pad + 1px divider + margins ≈ 176px */
  height: calc(100vh - 176px);
  flex: 1;
  padding: 4px 8px 16px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.sidebar-scroll::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}

/* ── Nav items ─────────────────────────────────── */
.sidebar-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  margin: 2px 0;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar-item::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0);
  transition: background 0.22s ease;
}

.sidebar-item:hover::before {
  background: rgba(255, 255, 255, 0.07);
}

.sidebar-item:hover {
  transform: translateX(3px);
}

.sidebar-item:hover .sidebar-icon {
  color: #7eb95f !important;
  text-shadow: 0 0 10px rgba(126, 185, 95, 0.6) !important;
}

.sidebar-item:hover .sidebar-label {
  color: #ffffff;
}

/* Active state */
.sidebar-item--active {
  background: #7eb95f !important;
  border: 1px solid rgba(126, 185, 95, 0.3) !important;
  box-shadow: 0 4px 12px rgba(126, 185, 95, 0.25) !important;
}

.sidebar-item--active .sidebar-icon {
  color: #102411 !important;
}

.sidebar-item--active .sidebar-label {
  color: #102411 !important;
  font-weight: 700 !important;
}

.sidebar-item--active .sidebar-active-bar {
  display: block !important;
  position: absolute !important;
  right: 0 !important;
  top: 25% !important;
  width: 3px !important;
  height: 50% !important;
  background: #102411 !important;
  border-radius: 4px 0 0 4px !important;
  box-shadow: 0 0 8px rgba(16, 36, 17, 0.7) !important;
}

.sidebar-active-bar {
  display: none;
}

/* Icon & label ────────────────────────────────── */
.sidebar-icon {
  color: rgba(255, 255, 255, 0.45) !important;
  font-size: 18px !important;
  flex-shrink: 0;
  transition: color 0.2s ease, text-shadow 0.2s ease;
}

.sidebar-label {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.65);
  letter-spacing: 0.3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.2s ease;
}

/* Child items (nested) ────────────────────────── */
.sidebar-item--child {
  padding-left: 22px;
}

.sidebar-item--child .sidebar-label {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.5);
}

/* Vuetify list-group override inside sidebar ──── */
.sidebar-group .v-list-group__header {
  padding: 0 !important;
  min-height: unset !important;
  background: transparent !important;
}

.sidebar-group .v-list-group__items {
  background: transparent !important;
}

.group-activator {
  width: 100%;
}
</style>